<template>
  <div
    class="container xl:container xl:mx-auto w-full relative flex justify-around px-5 xl:flex-row flex-col py-24"
  >
    <div class="xl:w-2/4 w-full">
      <!-- <p class="text-3xl font-semibold text-darkPurple">
        {{ prediction.description }}
      </p> -->
      <div
        class="flex md:flex-row flex-col justify-between mt-10"
        style="height: 50vh"
      >
        <div class="flex flex-col justify-between h-full">
          <p class="text-gray-600">
            Event ID:
            <span class="text-darkPurple font-semibold">{{
              prediction._id
            }}</span>
          </p>

          <p class="text-gray-600">
            Zonal office:
            <span class="text-darkPurple font-semibold">{{
              eventObj.zonal_office
            }}</span>
          </p>

          <p class="text-gray-600">
            Contaminant:
            <span class="text-darkPurple font-semibold">{{
              eventObj.contaminant
            }}</span>
          </p>

          <p class="text-gray-600">
            Type of facility:
            <span class="text-darkPurple font-semibold">{{
              eventObj.facility
            }}</span>
          </p>

          <p class="text-gray-600">
            Site location name:
            <span class="text-darkPurple font-semibold">{{
              eventObj.location
            }}</span>
          </p>
          <p class="text-gray-600">
            LGA
            <span class="text-darkPurple font-semibold">{{
              eventObj.lga
            }}</span>
          </p>

          <p class="text-gray-600">
            Estimated spill area:
            <span class="text-darkPurple font-semibold">{{
              eventObj.Estimated_spill_area
            }}</span>
          </p>

          <p class="text-gray-600">
            JIV date:
            <span class="text-darkPurple font-semibold">{{
              eventObj.jiv_date
            }}</span>
          </p>

          <p class="text-gray-600">
            Last updated by:
            <span class="text-darkPurple font-semibold">{{
              prediction.prediction_time
            }}</span>
          </p>
        </div>

        <div class="flex flex-col justify-between h-full">
          <p class="text-gray-600">
            Status:
            <span class="text-darkPurple font-semibold">{{
              eventObj.status
            }}</span>
          </p>

          <p class="text-gray-600">
            Event date:
            <span class="text-darkPurple font-semibold">{{
              prediction.prediction_time
            }}</span>
          </p>

          <p class="text-gray-600">
            Caption time:
            <span class="text-darkPurple font-semibold">{{
              prediction.capture_time
            }}</span>
          </p>

          <p class="text-gray-600">
            Cause:
            <span class="text-darkPurple font-semibold">{{
              eventObj.Cause
            }}</span>
          </p>

          <p class="text-gray-600">
            Threat level:
            <span class="text-darkPurple font-semibold">{{
              prediction.threat
            }}</span>
          </p>

          <p class="text-gray-600">
            Latitude:
            <span class="text-darkPurple font-semibold">{{
              eventObj.Latitude
            }}</span>
          </p>

          <p class="text-gray-600">
            Longitude:
            <span class="text-darkPurple font-semibold">{{
              eventObj.Longitude
            }}</span>
          </p>

          <p class="text-gray-600">
            Spill area habitat:
            <span class="text-darkPurple font-semibold">{{
              eventObj.Spill_area_habitat
            }}</span>
          </p>

          <p class="text-gray-600">
            Initial containment measures:
            <span class="text-darkPurple font-semibold">{{
              eventObj.Initial_containment_measures
            }}</span>
          </p>
        </div>
      </div>
      <p class="text-gray-600 mt-20 md:mt-10">
        Description of impact:
        <span class="text-darkPurple font-semibold">{{ eventObj.impact }}</span>
      </p>

      <p class="text-gray-600 mt-10">
        Present at JIV:
        <span class="text-darkPurple font-semibold">{{
          eventObj.jiv_present
        }}</span>
      </p>
      <div class="flex flex-col xl:flex-row">
        <div class="lg:mr-40">
          <p class="text-xl text-darkPurple font-semibold py-5">Attachments:</p>
          <div class="flex my-3">
            <img
              src="@/assets/images/feather-paperclip.svg"
              alt="link_icon"
              width="20px"
            />
            <p class="text-xl mx-5 text-blue">JIV FORM</p>
          </div>
          <div class="flex my-3">
            <img
              src="@/assets/images/feather-paperclip.svg"
              alt="link_icon"
              width="20px"
            />
            <p class="text-xl mx-5 text-blue">JIV PICS 1</p>
          </div>
          <div class="flex my-3">
            <img
              src="@/assets/images/feather-paperclip.svg"
              alt="link_icon"
              width="20px"
            />
            <p class="text-xl mx-5 text-blue">JIV PICS 2</p>
          </div>
          <div class="flex my-3">
            <img
              src="@/assets/images/feather-paperclip.svg"
              alt="link_icon"
              width="20px"
            />
            <p class="text-xl mx-5 text-blue">JIV PICS 3</p>
          </div>
        </div>
        <div>
          <p class="text-xl text-darkPurple font-semibold py-5">Video link:</p>
          <p class="text-xl py-5 text-blue break-words">
            https://ame.thesewer.com/view/e1bfe14\
          </p>
        </div>
      </div>
    </div>

    <div class="w-full xl:w-3/12 md:w-2/4 xl:mt-1 mt-8 relative">
      <div class="bg-blue flex flex-col rounded-xl p-10 xl:fixed">
        <img
          :src="prediction.image"
          alt="image"
          width="296px"
          height="296px"
          class="singleImage"
        />
        <button
          class="focus:outline-none bg-white rounded-lg text-blue text-xl w-full p-3 font-semibold mt-10"
        >
          <router-link :to="`/media/${prediction._id}`">View Media</router-link>
        </button>
        <button
          @click="triggerOverlay"
          class="focus:outline-none bg-blue border-white-500 border-2 rounded-lg text-white text-xl w-full font-semibold p-3 mt-10"
        >
          Send a report
        </button>
        <div class="flex my-10 justify-center">
          <img
            src="@/assets/images/material-content-copy.svg"
            alt="link_icon"
            width="20px"
          />
          <p class="text-xl mx-5 text-white">Copy Event ID</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      overLayOpen: false,
      eventObj: {
        event_id: "",
        zonal_office: "Null",
        contaminant: "Null",
        facility: "Null",
        location: "Null",
        lga: " Null",
        Estimated_spill_area: "Null",
        jiv_date: "Null",
        Last_updated: " 2020-10-30 PH133",
        status: "Success",
        Event_date: "24/10/2020",
        Report_date: "29/10/2020",
        Cause: "Null",
        Threat_level: "80%",
        Latitude: "Null",
        Longitude: "Null",
        Spill_area_habitat: "Null",
        Initial_containment_measures: "Null",
        impact: "Null",
        jiv_present: "Null"
      }
    };
  },
  methods: {
    triggerOverlay() {
      this.$emit("openOverlay", (this.overLayOpen = true));
    }
  },
  computed: {
    ...mapGetters({
      prediction: "events/prediction"
    })
  }
};
</script>

<style>
.singleImage {
  height: 296px;
}
</style>
